import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [activeModal, setActiveModal] = useState<string | null>(null);
  const termsContent = <div className="space-y-4" data-id="element-51">
      <h3 className="font-bold text-lg text-brand-dark" data-id="element-52">1. Termos de Uso</h3>
      <p data-id="element-53">
        Ao acessar e utilizar o "Protocolo Desincha40+", você aceita cumprir com
        estes termos e condições.
      </p>
      <h3 className="font-bold text-lg text-brand-dark" data-id="element-54">
        2. Propriedade Intelectual
      </h3>
      <p data-id="element-55">
        Todo o conteúdo incluído é propriedade exclusiva dos criadores e está
        protegido por leis de direitos autorais. Não é permitida a
        redistribuição ou venda.
      </p>
      <h3 className="font-bold text-lg text-brand-dark" data-id="element-56">
        3. Isenção de Responsabilidade Médica
      </h3>
      <p data-id="element-57">
        Este material é estritamente educativo e informativo. Não substitui, de
        forma alguma, o aconselhamento, diagnóstico ou tratamento médico
        profissional. Sempre procure a orientação do seu médico ou outro
        profissional de saúde qualificado com qualquer dúvida que possa ter
        sobre uma condição médica.
      </p>
    </div>;
  const privacyContent = <div className="space-y-4" data-id="element-58">
      <h3 className="font-bold text-lg text-brand-dark" data-id="element-59">
        1. Informações que Coletamos
      </h3>
      <p data-id="element-60">
        Coletamos informações básicas de contato e dados de uso para melhorar
        sua experiência e processar sua compra de forma segura através de nossos
        parceiros de pagamento (Hotmart).
      </p>
      <h3 className="font-bold text-lg text-brand-dark" data-id="element-61">
        2. Proteção de Dados
      </h3>
      <p data-id="element-62">
        Implementamos medidas de segurança para proteger suas informações
        pessoais. Não vendemos seus dados para terceiros.
      </p>
    </div>;
  const contactContent = <div className="space-y-4" data-id="element-63">
      <h3 className="font-bold text-lg text-brand-dark" data-id="element-64">Contato</h3>
      <p data-id="element-65">
        Para suporte, dúvidas ou assistência com seu acesso ao Protocolo
        Desincha40+, entre em contato conosco:
      </p>
      <p className="font-medium" data-id="element-66">Email: suporte@desincha40mais.com</p>
      <p className="text-sm mt-4" data-id="element-67">
        Nosso horário de atendimento é de segunda a sexta, das 09h às 18h. O
        prazo de resposta é de até 48 horas úteis.
      </p>
    </div>;
  return <footer className="bg-brand-beige py-12 border-t border-brand-sage/50" data-id="element-68">
      <div className="max-w-5xl mx-auto px-5 md:px-8" data-id="element-69">
        <div className="flex flex-col items-center text-center space-y-6" data-id="element-70">
          <div className="font-serif font-bold text-2xl text-brand-dark" data-id="element-71">
            Desincha40+
          </div>

          <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm text-brand-text/70" data-id="element-72">
            <button onClick={() => setActiveModal('terms')} className="hover:text-brand-dark transition-colors" data-id="element-73">
              Termos de Uso
            </button>
            <button onClick={() => setActiveModal('privacy')} className="hover:text-brand-dark transition-colors" data-id="element-74">
              Política de Privacidade
            </button>
            <button onClick={() => setActiveModal('contact')} className="hover:text-brand-dark transition-colors" data-id="element-75">
              Contato
            </button>
          </div>

          <div className="max-w-2xl text-xs text-brand-text/60 leading-relaxed mt-8" data-id="element-76">
            <p className="mb-2" data-id="element-77">
              <strong data-id="element-78">Aviso Legal:</strong> Este material é educativo e não
              substitui orientação médica. Caso tenha pressão alta, diabetes,
              doença renal, use medicamentos ou tenha qualquer condição de
              saúde, consulte seu médico antes de iniciar. Resultados
              individuais podem variar. O sucesso depende da aplicação
              consistente das estratégias apresentadas.
            </p>
            <p data-id="element-79">© 2026 Protocolo Desincha40+. Todos os direitos reservados.</p>
          </div>
        </div>
      </div>

      <LegalModal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Termos de Uso" content={termsContent} data-id="element-80" />
      <LegalModal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidade" content={privacyContent} data-id="element-81" />
      <LegalModal isOpen={activeModal === 'contact'} onClose={() => setActiveModal(null)} title="Contato" content={contactContent} data-id="element-82" />
    </footer>;
}